import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function arabicOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim();

    if (!value) return null;

    const arabicRegex = /^[\u0600-\u06FF0-9\s-]+$/;

    return arabicRegex.test(value) ? null : { arabicOnly: true };
  };
}

export function englishOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value?.trim();

    if (!value) return null;

    const englishRegex = /^[a-zA-Z0-9 '-]+$/;

    return englishRegex.test(value) ? null : { englishOnly: true };
  };
}

export function noLeadingTrailingSpacesValidator() {
  return (control: AbstractControl) => {
    const value = control.value;

    if (!value) return null;

    return value.trim() === value ? null : { spaces: true };
  };
}

export function noNumbersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    return /\d/.test(value) ? { numbers: true } : null;
  };
}